//import action types
import * as types from "../actions/types"

const initialState = {
  newUser: [],
  error: []
};

const userSignupReducer = (variable = initialState, action) => {
    const { type, payload } = action;
    switch(action.type){
      case types.signup_success:
        return {
          ...variable,
          newUser: action.payload
        };
      case types.signup_failure:
        return {
          ...variable,
          error: action.payload
        };
      default:
        return variable;
    }
  };


export default userSignupReducer;
